import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import InputRegionSelector from '../Components/InputSpecialFields/InputRegionSelector';
import InputAMSelector from '../Components/InputSpecialFields/InputAMSelector';

import Loading from '../Components/Loading';
import WarningPanel from '../Components/WarningPanel';
import HeadlinePanel from '../Components/HeadlinePanel';

import styles from '../styles/Unloading.module.css';

const Unloading = () => {
  const { openTimeModal } = useTimeModal();

  const [isFormChanged, setIsFormChanged] = React.useState(false);
  const [formInfo, setFormInfo] = React.useState({
    filter_type: '',
    date_start: '',
    date_end: '',
    region_id: '',
    region_name: '',
    am_id: '',
    am_email: '',
    procedure: '',
  });

  const [loading, setLoading] = React.useState(false);
  const [warning, setWarning] = React.useState('');
  const [status, setStatus] = React.useState(<a></a>);

  const handleChange = (field) => (e) => {
    const value = e.target.value;

    setFormInfo((prev) => ({ ...prev, [field]: value }));
    setIsFormChanged(true);

    setErrorsForm((prevErrors) => {
      if (!prevErrors[field]) return prevErrors;
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const [errorsForm, setErrorsForm] = React.useState({});
  const validateForm = () => {
    const newErrors = {};

    if (!formInfo.filter_type) {
      newErrors.filter_type = 'Выберите фильтр';
    }
    if (!formInfo.date_start) {
      newErrors.date_start = 'Обязательное поле';
    }
    if (!formInfo.date_end) {
      newErrors.date_end = 'Обязательное поле';
    }
    if (formInfo.date_end < formInfo.date_start) {
        newErrors.date_start = 'Укажите корректный срок';
        newErrors.date_end = 'Укажите корректный срок';
    }


    setErrorsForm(newErrors);
    if (Object.keys(newErrors).length > 0) {
        setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
        return false;
    } else {
        return true;
    }
  };

  const unloadData = async () => {
    if (!formInfo.date_start || !formInfo.date_end || new Date(formInfo.date_start) > new Date(formInfo.date_end)) {
        return openTimeModal('Введите корректный период для выгрузки. Конечная дата должна быть позже, чем дата начала', 'error');
    }

    try {
        setLoading(true);
        const token = localStorage.getItem('token');

        const response = await axios.get('/api/download-cases-excel', {
            responseType: 'blob',
            headers: { Authorization: `Bearer ${token}` },
            params: {
                dateStart: formInfo.date_start,
                dateEnd: formInfo.date_end,
                filterType: formInfo.filter_type,
                region: formInfo.region,
                procedure: formInfo.procedure,
                emailAM: formInfo.emailAM
            }
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Выгрузка_${formInfo.date_start}_по_${formInfo.date_end}.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);

        setLoading(false);
        setStatus(<a>Файл сейчас загрузится. Можете продолжать использование системы</a>);
    } catch (error) {
        console.error(error);
        setStatus(<a className='mainLabelError'>{error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        setLoading(false);
    }
  };

  const handleSave = () => {
    setLoading(true);
    setStatus(<a><Loading type='inline' /></a>);
    if (validateForm()) {
      unloadData();
    }
    setLoading(false);
  };
  

  return (
    <div className='mainContainer'>
        <HeadlinePanel label='Выгрузка данных' type='На главную' />
        <div className='containerInner'>
            <div className='pageLimiter'>
                {warning ? <WarningPanel text={warning} />
                :
                <>
                    <h3 className='formHeadline'>Укажите период</h3>
                    <div className='labelInputWrapper'>
                        <a className='label'>Тип даты для фильтрации</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper verticalRSWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_start' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_start'
                                        checked={formInfo.filter_type === 'date_start'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата начала учёта</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_end' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_end'
                                        checked={formInfo.filter_type === 'date_end'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Конечная дата предоставления отчета</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_procedure_start_m' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_procedure_start_m'
                                        checked={formInfo.filter_type === 'date_procedure_start_m'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата введения процедуры (полная версия)</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_procedure_start_r' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_procedure_start_r'
                                        checked={formInfo.filter_type === 'date_procedure_start_r'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата введения процедуры (рез. часть)</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_submission_candidate' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_submission_candidate'
                                        checked={formInfo.filter_type === 'date_submission_candidate'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата выбора управляющего</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_court' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_court'
                                        checked={formInfo.filter_type === 'date_court'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата судебного заседания</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_am_appointment_m' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_am_appointment_m'
                                        checked={formInfo.filter_type === 'date_am_appointment_m'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата утверждения управляющего АС (полная версия)</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.filter_type === 'date_am_appointment_r' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='date_am_appointment_r'
                                        checked={formInfo.filter_type === 'date_am_appointment_r'}
                                        onChange={handleChange('filter_type')}
                                    />
                                    <span>Дата утверждения управляющего АС (рез.часть)</span>
                                </label>
                            </div>
                            {errorsForm.filter_type && <div className='errorUnderInput'>{errorsForm.filter_type}</div>}
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Начальная дата периода</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                            <input type='date' 
                                value={formInfo.date_start?.split('T')[0]}
                                onChange={handleChange('date_start')} 
                                className={errorsForm.date_start ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                required />
                            {errorsForm.date_start && <div className='errorUnderInput'>{errorsForm.date_start}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Конечная дата периода</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                            <input type='date' 
                                value={formInfo.date_end?.split('T')[0]}
                                onChange={handleChange('date_end')} 
                                className={errorsForm.date_end ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                required />
                            {errorsForm.date_end && <div className='errorUnderInput'>{errorsForm.date_end}</div>}
                            </div>
                        </div>
                    </div>

                    <div style={{height: '20px'}}></div>

                    <div>
                        <h3 className='formHeadline'>Дополнительные параметры</h3>
                        <p className='description'>Предварительная версия. Возможна некорректная работа</p>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Укажите тип дополнительного фильтра</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.additional_type === 'region' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='region'
                                        checked={formInfo.additional_type === 'region'}
                                        onChange={handleChange('additional_type')}
                                    />
                                    <span>По региону</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.additional_type === 'am_email' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='am_email'
                                        checked={formInfo.additional_type === 'am_email'}
                                        onChange={handleChange('additional_type')}
                                    />
                                    <span>По арбитражному управляющему</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.additional_type === 'procedure' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='procedure'
                                        checked={formInfo.additional_type === 'procedure'}
                                        onChange={handleChange('additional_type')}
                                    />
                                    <span>По процедуре</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    {formInfo.additional_type === 'region' &&
                    <div className='labelInputWrapper'>
                        <a className='label'>Регион арбитражных управляющих</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                            <InputRegionSelector
                                initialSearchTerm={formInfo.region_name}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                            />
                            {errorsForm.region && <div className='errorUnderInput'>{errorsForm.region}</div>}
                            </div>
                        </div>
                    </div>}

                    {formInfo.additional_type === 'am_email' &&
                    <div className='labelInputWrapper'>
                        <a className='label'>Адрес электронной почты управляющего</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                            <InputAMSelector
                                initialSearchTerm={formInfo.am_email}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                            />
                            {errorsForm.am && <div className='errorUnderInput'>{errorsForm.am}</div>}
                            </div>
                        </div>
                    </div>}

                    {formInfo.additional_type === 'procedure' &&
                    <div className='labelInputWrapper'>
                        <a className='label'>Процедура</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                            <input type='text' 
                                value={formInfo.procedure} 
                                onChange={handleChange('procedure')} 
                                className={errorsForm.procedure ? 'inputError' : ''}
                                placeholder='Необязательно' 
                                minLength='' 
                                maxLength='' 
                                required 
                            />
                            {errorsForm.procedure && <div className='errorUnderInput'>{errorsForm.procedure}</div>}
                            </div>
                        </div>
                    </div>}

                    {isFormChanged &&
                    <div className='panelFormConfirmation'>
                        <button type='button' className='button' onClick={handleSave}>Выгрузить таблицу</button>
                        <div>{status}</div>
                    </div>
                    }
                </>
                }
                </div>
            </div>
        </div>
    )
}

export default Unloading;
